import LabourTrendsCard from "@shared-containers/LabourTrendsCard";
import EmployeePayTable from "@shared-containers/EmployeePayTable";
import LabourBreakdownTable from "@shared-containers/LabourBreakdownTable";
import ShiftInformationTable from "@shared-containers/ShiftInformationTable";
import { DEVICE, useWindowSizeChanged } from "@hooks/DeviceSize";
import { CustomCardWrapper, StyledRootBox } from "./style";

const CogsDashBoard = () => {
  const device = useWindowSizeChanged();
  const isDesktop = device === DEVICE.DESKTOP;
  return (
    <StyledRootBox isDesktop={isDesktop}>
      <CustomCardWrapper isDesktop={isDesktop}>
        <LabourTrendsCard />
      </CustomCardWrapper>
      <CustomCardWrapper isDesktop={isDesktop}>
        <LabourBreakdownTable pagination={false} />
      </CustomCardWrapper>
      <CustomCardWrapper isDesktop={isDesktop}>
        <EmployeePayTable pagination={false} />
      </CustomCardWrapper>
      <CustomCardWrapper isDesktop={isDesktop}>
        <ShiftInformationTable pagination={false} />
      </CustomCardWrapper>
    </StyledRootBox>
  );
};

export default CogsDashBoard;
